import { useTranslation } from "react-i18next";
import SectionHeader from "../common/SectionHeader";
import LandingProductCard from "./LandingProductCard";
import { getLandingProductsSection } from "../../utils/landingAcf";
import { SECTION_CONTAINER } from "../../utils/layout";
import LandingSection from "./LandingSection";
import ScrollReveal, { revealItemProps } from "./ScrollReveal";
import SectionLoader from "../common/SectionLoader";
import "./LandingSections.css";

function LandingProducts({ acf, resolveMedia, loading = false }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <LandingSection className="landing-products">
        <SectionLoader size="lg" label={t("Loading section")} />
      </LandingSection>
    );
  }

  const { title, description, products } = getLandingProductsSection(acf);

  if (products.length === 0) return null;

  const sectionTitle = title || t("Products");
  const sectionDescription =
    description ||
    t(
      "Explore our premium sports flooring options at Caf Sports, designed for superior performance and safety. Contact us today for customized solutions and expert guidance",
    );

  return (
    <LandingSection className="landing-products">
      <ScrollReveal className="landing-section__intro">
        <SectionHeader
          title={sectionTitle}
          subtitle={sectionDescription}
          showAccent
          centered
          titleId="landing-products-title"
          containerClass=""
        />
      </ScrollReveal>
      <div className={SECTION_CONTAINER}>
        <ScrollReveal
          className="caf-product-grid landing-section__body"
          stagger
          aria-labelledby="landing-products-title"
        >
          {products.map((product, index) => (
            <LandingProductCard
              key={product.id}
              product={product}
              image={resolveMedia(product.imageId)}
              {...revealItemProps(index)}
            />
          ))}
        </ScrollReveal>
      </div>
    </LandingSection>
  );
}

export default LandingProducts;
